export const MSA_ACCESS = 'msa:access'
export const REPORTING_ACCESS = 'reporting:access'
export const PLAYLIST_MANAGE_PLAYLIST =
  'playlist:manage-playlist'
